<div class="spinner d-flex" *ngIf="isbusy">
  <div class="spinner-border text-primary" role="status">
    <span class="sr-only"></span>
  </div>
</div>
